<template>
  <div style="margin: 0 0 12px;">
    <div style="display: flex; align-items: center; margin: 0 16px">
      <el-input type="textarea" :rows="4" v-model="phones" placeholder="请输入手机号，多个手机号可通过分号做间隔" style="width: 100%; flex: 1"/>
    </div>
    <div style="background-color: #ffffff; padding: 12px 16px; border-radius: 8px;margin: 0 0 16px; color: #aaaaaa">
      <p style="margin-bottom: 4px">请输入手机号，多个手机号可通过分号做间隔</p>
      <p>例：15200000001;15200000002</p>
    </div>
    <div class="dialog-footer" style="text-align: center; margin-top: 16px;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit">确定</el-button>
    </div>
  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateNotifyPhone} from "@/api/url";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      phones: this.value.phones,
    }
  },
  methods: {



    cancel() {
      this.$emit("close");
    },
    summit() {
      // if(!this.remarkForm.remark) {
      //   this.$message({
      //     showClose: true,
      //     duration: 2000,
      //     message: '请输入价格',
      //     type: 'warning'
      //   });
      //   return false
      // }
      let param = {}
      param['phones'] = this.phones
      postFormData(updateNotifyPhone, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },





  },
  mounted() {
  }
}
</script>

<style scoped>

</style>
